module.exports = __webpack_public_path__ + "static/media/shuttleIcon.71e4eb59.png";